const COMPANY_PERMISSION_CODES = ["FT001", "FT002", "FT003", "FT004", "FT2302", "FT2303", "FT2304", "FT2305", "FT2306"];

export default [
  {
    path: "/",
    redirect: window.MyConfig.defaultRouter,
    component: () => import ("@/containers/DefaultContainer")
  },
  {
    path: "/admin",
    redirect: "/admin/home",
    component: () => import ("@/containers/DefaultContainer"),
    children: [
      //blankPage
      {
        path: "developing-page",
        name: "Admin-BlankPage",
        component: () => import ("@/views/admin/BlankPage/BlankPage"),
        meta: {
          allowAccess: ["*"],
          page: "admin",
          code: ["*"],
          breadCrumb: [],
          isOrtherModule: true,
          collection: 'Timekeeping',
        }
      },
      //dashboard-ceo
      {
        path: "dashboard-ceo",
        name: "Admin-CEO-Dashboard",
        component: () => import("@/views/admin/RoleDashboard/DashboardCEO"),
        meta: {
          allowAccess: ["CEO"],
          page: "admin",
          code: ["*"],
          collection: 'DashboardCEO',
        }
      },
      //dashboard-hr
      {
        path: "dashboard-hr",
        name: "Admin-Hr-Dashboard",
        component: () => import("@/views/admin/RoleDashboard/HrDashboard"),
        meta: {
          allowAccess: ["HR"],
          page: "admin",
          code: ["*"],
          collection: 'DashboardHR',
          breadCrumb: [
            {
              title: 'Trang chủ',
              url: ''
            }
          ]
        }
      },
      //dashboard-business
      {
        path: "dashboard-business",
        name: "Admin-Business-Dashboard",
        component: () => import("@/views/admin/RoleDashboard/BusinessDashboard"),
        meta: {
          allowAccess: ["KD"],
          page: "admin",
          code: ["*"],
          collection: 'DashboardBusiness',
          breadCrumb: [
            {
              title: 'Trang chủ',
              url: ''
            }
          ]
        }
      },
      //dashboard-individual
      {
        path: "dashboard-individual",
        name: "Admin-Individual-Dashboard",
        component: () => import("@/views/admin/Dashboard/DashboardNhanVien"),
        meta: {
          allowAccess: ["*"],
          page: "admin",
          code: ["*"],
          collection: 'DashboardIndividual',
          breadCrumb: [
            {
              title: 'Trang chủ',
              url: ''
            }
          ]
        }
      },
      //income-information
      {
        path: "income-information",
        name: "Admin-Income-Information",
        component: () => import("@/views/admin/IncomeInformation/IncomeInformation"),
        meta: {
          allowAccess: ["*"],
          page: "admin",
          code: ["*"],
          collection: 'DashboardIndividual',
          breadCrumb: [
            {
              title: 'Trang chủ',
              url: ''
            }
          ]
        }
      },
      //home
      {
        path: "home",
        name: "Admin-Home",
        component: () => import ("@/views/admin/Dashboard/Dashboard"),
        meta: {
          allowAccess: ["Customer"],
          page: "admin",
          code: ["FT1401"],
          breadCrumb: [
            {
              title: 'Trang chủ',
              url: ''
            }
          ],
          isOrtherModule: true,
          collection: 'Timekeeping'
        }
      },
      {
        path: "lunch-registration",
        name: "Admin-LunchRegistration",
        component: () => import ("@/views/admin/LunchRegistration/LunchRegistration"),
        meta: {
          allowAccess: ["Customer"],
          page: "admin",
          code: ["*"],
          breadCrumb: [
            {
              title: 'Đăng ký cơm trưa',
              url: ''
            }
          ],
          isOrtherModule: true,
          collection: 'Timekeeping'
        }
      },
      {
        path: "lunch-menu-management",
        name: "Admin-LunchMenuManagement",
        component: () => import ("@/views/admin/LunchRegistration/LunchMenuManagement"),
        meta: {
          allowAccess: ["Customer"],
          page: "admin",
          code: ["FT2401"],
          breadCrumb: [
            {
              title: 'Quản lý danh sách món',
              url: ''
            }
          ],
          isOrtherModule: true,
          collection: 'Timekeeping'
        }
      },
      {
        path: "lunch-menu-schedule-management",
        name: "Admin-LunchMenuScheduleManagement",
        component: () => import ("@/views/admin/LunchRegistration/LunchMenuScheduleManagement"),
        meta: {
          allowAccess: ["Customer"],
          page: "admin",
          code: ["FT2402"],
          breadCrumb: [
            {
              title: 'Quản lý thực đơn',
              url: ''
            }
          ],
          isOrtherModule: true,
          collection: 'Timekeeping'
        }
      },
      {
        path: "lunch-registration-list",
        name: "Admin-LunchRegistrationList",
        component: () => import ("@/views/admin/LunchRegistration/LunchRegistrationList"),
        meta: {
          allowAccess: ["Customer"],
          page: "admin",
          code: ["FT2403"],
          breadCrumb: [
            {
              title: 'Danh sách đăng ký cơm',
              url: ''
            }
          ],
          isOrtherModule: true,
          collection: 'Timekeeping'
        }
      },
      {
        path: "lunch-registration-history",
        name: "Admin-LunchRegistrationHistory",
        component: () => import ("@/views/admin/LunchRegistration/LunchRegistrationHistory"),
        meta: {
          allowAccess: ["Customer"],
          page: "admin",
          code: ["*"],
          breadCrumb: [
            {
              title: 'Lịch sử đăng ký cơm',
              url: ''
            }
          ],
          isOrtherModule: true,
          collection: 'Timekeeping'
        }
      },
      //hello
      {
        path: "hello",
        name: "Admin-Hello",
        component: () => import ("@/views/admin/Dashboard/HelloPage"),
        meta: {
          allowAccess: ["*"],
          page: "admin",
          code: ["*"],
          breadCrumb: [
            {
              title: 'Trang chủ',
              url: ''
            }
          ],
          // isOrtherModule: true,
          collection: 'HelloPage'
        }
      },
      //intermediary
      {
        path: "intermediary",
        name: "Admin-Intermediary",
        component: () => import ("@/views/admin/Dashboard/IntermediaryPage"),
        meta: {
          allowAccess: ["*"],
          page: "admin",
          code: ["*"],
          breadCrumb: [
            {
              title: 'Trang chủ',
              url: ''
            }
          ],
          isOrtherModule: true,
          collection: 'Timekeeping'
        }
      },
      //employee/home
      {
        path: "employee/home",
        name: "Admin-Home-Employee",
        component: () => import ("@/views/admin/Dashboard/DashboardNhanVien"),
        meta: {
          allowAccess: ["*"],
          page: "admin",
          code: ["FT1402"],
          breadCrumb: [
            {
              title: 'Trang chủ',
              url: ''
            }
          ],
          isOrtherModule: true,
          collection: 'Timekeeping'
        }
      },
      //EmployeeDayOffConfig
      {
        path: "EmployeeDayOffConfig",
        name: "Admin-EmployeeDayOffConfig-List",
        component: () => import ("@/views/admin/EmployeeDayOffConfig/EmployeeDayOffConfigList"),
        meta: {
          allowAccess: ["Customer"],
          page: "admin",
          code: ["FT406"],
          breadCrumb: [
            {
              title: 'Trang chủ',
              url: '/admin/hello'
            },
            {
              title: 'Cấu hình nghỉ phép nhân viên',
              url: ''
            }
          ],
          isOrtherModule: true,
          collection: 'Timekeeping'
        }
      },
      //EmployeeManager
      {
        path: "EmployeeManager",
        name: "Admin-EmployeeManager",
        redirect: "/admin/EmployeeManager/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "list",
            name: "Admin-EmployeeManager-list",
            component: () => import ("@/views/admin/Employees/EmployeeList"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT101"],
              breadCrumb: [
                // {
                //   title: 'Danh sách nhân viên',
                //   url: '/admin/EmployeeManager/list'
                // }
              ],
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          },
          {
            path: "detail/:id",
            name: "Admin-EmployeeManager-detail",
            component: () => import ("@/views/admin/Employees/EmployeeForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT102"],
              breadCrumb: [
                // {
                //   title: 'Danh sách nhân viên',
                //   url: '/admin/EmployeeManager/list'
                // },
                // {
                //   title: 'Chi tiết nhân viên',
                //   url: ''
                // }
              ],
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          },
          {
            path: "update/:id",
            name: "Admin-EmployeeManager-update",
            component: () => import ("@/views/admin/Employees/EmployeeForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT104", "FT102"],
              breadCrumb: [
                // {
                //   title: 'Danh sách nhân viên',
                //   url: '/admin/EmployeeManager/list'
                // },
                // {
                //   title: 'Cập nhật nhân viên',
                //   url: ''
                // }
              ],
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          },
          {
            path: "create",
            name: "Admin-EmployeeManager-create",
            component: () => import ("@/views/admin/Employees/EmployeeForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT103"],
              breadCrumb: [
                // {
                //   title: 'Danh sách nhân viên',
                //   url: '/admin/EmployeeManager/list'
                // },
                // {
                //   title: 'Thêm mới nhân viên',
                //   url: ''
                // }
              ],
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          },
          {
            path: "approve/:id",
            name: "Admin-EmployeeManager-approve",
            component: () => import ("@/views/admin/Employees/EmployeeForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT104", "FT102"],
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          }
        ]
      },
      //Timekeeping
      {
          path: "Timekeeping",
          name: "Admin-Timekeeping",
          redirect: "/admin/Timekeeping/SalaryPeriodConfig/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "TimekeepingConfig",
              name: "Admin-Timekeeping-TimekeepingConfig",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "SalaryPeriodConfig/list",
                  name: "Admin-Timekeeping-TimekeepingConfig-SalaryPeriodConfig-list",
                  component: () => import ("@/views/admin/Timekeeping/TimekeepingConfig/SalaryPeriod/SalaryPeriodConfigList"),
                  meta: {
                    allowAccess: ["Customer"],
                    page: "admin",
                    code: ["FT201"],
                    isOrtherModule: true,
                    collection: 'Timekeeping'
                  }
                },
                {
                  path: "AgentConnection",
                  name: "Admin-Timekeeping-TimekeepingConfig-AgentConnection",
                  component: () => import ("@/views/admin/Timekeeping/TimekeepingConfig/Agent/AgentConnection"),
                  meta: {
                    allowAccess: ["Customer"],
                    page: "admin",
                    code: ["FT301"],
                    breadCrumb: [
                      {
                        name: "Trang chủ",
                        path: "/admin/home"
                      },
                      {
                        name: "Chấm công",
                        path: "/admin/Timekeeping"
                      },
                      {
                        name: "Cấu hình chấm công",
                        path: "/admin/Timekeeping/TimekeepingConfig/AgentConnection"
                      },
                      {
                        name: "Kết nối Agent",
                        path: ""
                      }
                    ],
                    isOrtherModule: true,
                    collection: 'Timekeeping'
                  }
                },
                {
                  path: "AgentConnectionManagement/:id",
                  name: "Admin-Timekeeping-TimekeepingConfig-AgentConnectionManagement",
                  component: () => import ("@/views/admin/Timekeeping/TimekeepingConfig/Agent/AgentConnectionManagement"),
                  meta: {
                    allowAccess: ["Customer"],
                    page: "admin",
                    code: ["FT304"],
                    breadCrumb: [
                      {
                        name: "Trang chủ",
                        path: "/admin/home"
                      },
                      {
                        name: "Chấm công",
                        path: "/admin/Timekeeping"
                      },
                      {
                        name: "Cấu hình chấm công",
                        path: "/admin/Timekeeping/TimekeepingConfig/AgentConnection"
                      },
                      {
                        name: "Quản lý kết nối Agent",
                        path: ""
                      }
                    ],
                    isOrtherModule: true,
                    collection: 'Timekeeping'
                  }
                },
                {
                  path: "AgentMonitor",
                  name: "Admin-Timekeeping-TimekeepingConfig-AgentMonitor",
                  component: () => import ("@/views/admin/Timekeeping/TimekeepingConfig/Agent/AgentMonitor"),
                  meta: {
                    allowAccess: ["Customer"],
                    page: "admin",
                    code: ["FT301"],
                    isOrtherModule: true,
                    collection: 'Timekeeping'
                  }
                },
                {
                  path: "DayOffList",
                  name: "Admin-Timekeeping-TimekeepingConfig-DayOff-list",
                  component: () => import ("@/views/admin/Timekeeping/TimekeepingConfig/DayOffList"),
                  meta: {
                    allowAccess: ["Customer"],
                    page: "admin",
                    code: ["FT401"],
                    isOrtherModule: true,
                    collection: 'Timekeeping'
                  }
                },
                {
                  path: "Shift",
                  name: "Admin-Timekeeping-TimekeepingConfig-Shift",
                  redirect: "/admin/Timekeeping/Shift/list",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  children: [
                    {
                      path: "list",
                      name: "Admin-Timekeeping-TimekeepingConfig-Shift-list",
                      component: () => import ("@/views/admin/Timekeeping/TimekeepingConfig/Shift/ShiftList"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT701"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    },
                    {
                      path: "create",
                      name: "Admin-Timekeeping-TimekeepingConfig-Shift-create",
                      component: () => import ("@/views/admin/Timekeeping/TimekeepingConfig/Shift/ShiftForm"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT703"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    },
                    {
                      path: "detail/:id",
                      name: "Admin-Timekeeping-TimekeepingConfig-Shift-detail",
                      component: () => import ("@/views/admin/Timekeeping/TimekeepingConfig/Shift/ShiftForm"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT702"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    },
                    {
                      path: "update/:id",
                      name: "Admin-Timekeeping-TimekeepingConfig-Shift-update",
                      component: () => import ("@/views/admin/Timekeeping/TimekeepingConfig/Shift/ShiftForm"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT704"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    }
                  ]
                },
                {
                  path: "EntryAndExitHistoryCompanyList",
                  name: "Admin-Timekeeping-TimekeepingConfig-EntryAndExitHistoryCompanyList",
                  component: () => import ("@/views/admin/Timekeeping/TimekeepingConfig/EntryAndExitHistoryCompany/EntryAndExitHistoryCompanyList"),
                  meta: {
                    allowAccess: ["Customer"],
                    page: "admin",
                    code: ["FT1901"],
                    isOrtherModule: true,
                    collection: 'Timekeeping'
                  }
                },
                {
                  path: "WorkChangeHistory/list",
                  name: "Admin-Timekeeping-TimekeepingConfig-WorkChangeHistory-list",
                  component: () => import ("@/views/admin/Timekeeping/TimekeepingConfig/WorkChangeHistory/WorkChangeHistoryList"),
                  meta: {
                    allowAccess: ["Customer"],
                    page: "admin",
                    code: ["FT901", "FT902", "FT1001", "FT1003", "FT1004", "FT1006", "FT1007"],
                    isOrtherModule: true,
                    collection: 'Timekeeping'
                  }
                },
              ]
            },
            {
              path: "Worksheet",
              name: "Admin-Timekeeping-Worksheet",
              component: () => import ("@/views/admin/Timekeeping/Worksheet/WorksheetList"),
              meta: {
                allowAccess: ["Customer"],
                page: "admin",
                code: ["FT801"],
                isOrtherModule: true,
                collection: 'Timekeeping'
              }
            },
            {
              path: "Employee",
              name: "Admin-Timekeeping-Employee",
              redirect: "/admin/Timekeeping/Employee/EmployeeWorksheet",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "EmployeeWorksheet",
                  name: "Admin-Timekeeping-Employee-EmployeeWorksheet",
                  component: () => import ("@/views/admin/Timekeeping/Employee/EmployeeWorksheet"),
                  meta: {
                    allowAccess: ["Customer"],
                    page: "admin",
                    code: ["FT901"],
                    isOrtherModule: true,
                    collection: 'Timekeeping'
                  }
                },
                {
                  path: "EntryAndExitHistory",
                  name: "Admin-Timekeeping-Employee-EntryAndExitHistory",
                  component: () => import ("@/views/admin/Timekeeping/Employee/EntryAndExitHistory"),
                  meta: {
                    allowAccess: ["Customer"],
                    page: "admin",
                    code: ["FT902"],
                    isOrtherModule: true,
                    collection: 'Timekeeping'
                  }
                }
              ]
            }
          ]
      },
      //ManageRequests
      {
        path: "ManageRequests",
        name: "Admin-ManageRequests ",
        redirect: "/admin/ManageRequests/ListRequests",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "ListRequests",
            name: "Admin-ManageRequests-ListRequests",
            component: {
              render(c) {
                return c("router-view");
              }
            },
            children: [
              {
                path: "DayOffRequests",
                name: "Admin-ManageRequests-ListRequests-DayOffRequests",
                component: () => import ("@/views/admin/ManageRequests/Requests/DayOffRequests"),
                meta: {
                  allowAccess: ["Customer"],
                  page: "admin",
                  code: ["FT1004"],
                  isOrtherModule: true,
                  collection: 'Timekeeping'
                }
              },
              {
                path: "WorkAdditionRequests",
                name: "Admin-ManageRequests-ListRequests-WorkAdditionRequests",
                component: () => import ("@/views/admin/ManageRequests/Requests/WorkAdditionRequests"),
                meta: {
                  allowAccess: ["Customer"],
                  page: "admin",
                  code: ["FT1004"],
                  isOrtherModule: true,
                  collection: 'Timekeeping'
                }
              },
              {
                path: "GoLateRequests",
                name: "Admin-ManageRequests-ListRequests-GoLateRequests",
                component: () => import ("@/views/admin/ManageRequests/Requests/GoLateRequests"),
                meta: {
                  allowAccess: ["Customer"],
                  page: "admin",
                  code: ["FT1004"],
                  isOrtherModule: true,
                  collection: 'Timekeeping'
                }
              },
              {
                path: "GoHomeEarlyRequests",
                name: "Admin-ManageRequests-ListRequests-GoHomeEarlyRequests",
                component: () => import ("@/views/admin/ManageRequests/Requests/GoHomeEarlyRequests"),
                meta: {
                  allowAccess: ["Customer"],
                  page: "admin",
                  code: ["FT1004"],
                  isOrtherModule: true,
                  collection: 'Timekeeping'
                }
              },
              {
                path: "GoOutRequests",
                name: "Admin-ManageRequests-ListRequests-GoOutRequests",
                component: () => import ("@/views/admin/ManageRequests/Requests/GoOutRequests"),
                meta: {
                  allowAccess: ["Customer"],
                  page: "admin",
                  code: ["FT1004"],
                  isOrtherModule: true,
                  collection: 'Timekeeping'
                }
              },
              {
                path: "GoOnBussinessRequests",
                name: "Admin-ManageRequests-ListRequests-GoOnBussinessRequests",
                component: () => import ("@/views/admin/ManageRequests/Requests/GoOnBussinessRequests"),
                meta: {
                  allowAccess: ["Customer"],
                  page: "admin",
                  code: ["FT1004"],
                  isOrtherModule: true,
                  collection: 'Timekeeping'
                }
              },
              {
                path: "TimeKeepingOnlineRequests",
                name: "Admin-ManageRequests-ListRequests-TimeKeepingOnlineRequests",
                component: () => import ("@/views/admin/ManageRequests/Requests/TimeKeepingOnlineRequests"),
                meta: {
                  allowAccess: ["Customer"],
                  page: "admin",
                  code: ["FT1004"],
                  isOrtherModule: true,
                  collection: 'Timekeeping'
                }
              },
              {
                path: "OTRequests",
                name: "Admin-ManageRequests-ListRequests-OTRequests",
                component: () => import ("@/views/admin/ManageRequests/Requests/OTRequests"),
                meta: {
                  allowAccess: ["Customer"],
                  page: "admin",
                  code: ["FT1004"],
                  isOrtherModule: true,
                  collection: 'Timekeeping'
                }
              }
            ]
          },
          {
            path: "RequestsWaitingForApproval",
            name: "Admin-ManageRequests-RequestsWaitingForApproval",
            component: () => import ("@/views/admin/ManageRequests/RequestsWaitingForApproval"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          },
          {
            path: "CheckRequest/:id",
            name: "Admin-ManageRequests-CheckRequest",
            component: () => import ("@/views/admin/ManageRequests/Requests/CheckRequest"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          },
          {
            path: "create",
            name: "Admin-ManageRequests-create",
            component: () => import ("@/views/admin/ManageRequests/YeuCauForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT1401"],
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          }
        ]
      },
      //Personal-request
      {
        path: "personal-request",
        name: "Admin-Personal-Request",
        component: () => import("@/views/admin/ManageRequests/ListRequestPersonal"),
        meta: {
          allowAccess: ["*"],
          page: "admin",
          code: ["*"],
          collection: 'DashboardIndividual',
          breadCrumb: [
            // {
            //   title: 'Trang chủ',
            //   url: '/admin/dashboard-individual'
            // },
            // {
            //   title: 'Danh sách yêu cầu',
            //   url: ''
            // }
          ]
        }
      },
      //SalaryEmployee
      {
        path: "SalaryEmployee",
        name: "Admin-SalaryEmployee",
        redirect: "/admin/SalaryEmployee/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "list",
            name: "Admin-SalaryEmployee-list",
            component: () => import ("@/views/admin/Salary/SalaryEmployee/SalaryEmployee"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT1201"],
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          },
          {
            path: "detail/:id",
            name: "Admin-SalaryEmployee-detail",
            component: () => import ("@/views/admin/Salary/SalaryEmployee/SalaryEmployee"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          }
        ]
      },
      //Salary
      {
          path: "Salary",
          name: "Admin-Salary",
          redirect: "/admin/Salary/SalaryPeriodList",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [{
                  path: "SalaryPeriod",
                  name: "Admin-Salary-SalaryPeriod",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  children: [
                    {
                      path: "SalaryPeriodList",
                      name: "Admin-Salary-SalaryPeriod-SalaryPeriodList",
                      component: () => import ("@/views/admin/Salary/SalaryPeriod/SalaryPeriodList"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT1101"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    },
                    {
                      path: "detail/:id",
                      name: "Admin-Salary-SalaryPeriod-SalaryPeriodList-detail",
                      component: () => import ("@/views/admin/Salary/SalaryPeriod/SalaryPeriodForm"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT1102"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    },
                    {
                      path: "create",
                      name: "Admin-Salary-SalaryPeriod-SalaryPeriodList-create",
                      component: () => import ("@/views/admin/Salary/SalaryPeriod/SalaryPeriodForm"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT1103"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    },
                    {
                      path: "update/:id",
                      name: "Admin-Salary-SalaryPeriod-SalaryPeriodList-update",
                      component: () => import ("@/views/admin/Salary/SalaryPeriod/SalaryPeriodForm"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT1103"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    }
                  ]
              },
              {
                  path: "SalaryCompany",
                  name: "Admin-Salary-SalaryCompany",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  children: [
                    {
                      path: "SalaryCompany",
                      name: "Admin-Salary-SalaryCompany-SalaryCompany",
                      component: () => import ("@/views/admin/Salary/SalaryCompany/SalaryCompany"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT1101"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    }
                  ]
              },
              {
                  path: "SalaryConfig",
                  name: "Admin-Salary-SalaryConfig",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  children: [
                    {
                      path: "SalaryConfig",
                      name: "Admin-Salary-SalaryConfig-SalaryConfig",
                      component: () => import ("@/views/admin/Salary/SalaryConfig/SalaryConfig"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT1101"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    },
                    {
                      path: "History",
                      name: "Admin-Salary-SalaryConfig-History",
                      component: () => import ("@/views/admin/Salary/SalaryConfig/SalaryConfigHistory"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT1101"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    }
                  ]
              }
          ]
      },
      //System/Company
      {
        path: "System/Company",
        name: "Admin-Company",
        redirect: "/admin/System/Company/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "list",
            name: "Admin-Company-list",
            component: () => import ("@/views/admin/Company/CompanyList"),
            meta: {
              allowAccess: ["AdminSystem", "Customer"],
              page: "admin",
              code: COMPANY_PERMISSION_CODES,
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          },
          {
            path: "detail/:id",
            name: "Admin-Company-detail",
            component: () => import ("@/views/admin/Company/CompanyForm"),
            meta: {
              allowAccess: ["AdminSystem", "Customer"],
              page: "admin",
              code: COMPANY_PERMISSION_CODES,
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          },
          {
            path: "create",
            name: "Admin-Company-create",
            component: () => import ("@/views/admin/Company/CompanyForm"),
            meta: {
              allowAccess: ["AdminSystem", "Customer"],
              page: "admin",
              code: ["FT002", "FT2302"],
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
          },
          {
            path: "update/:id",
            name: "Admin-Company-update",
            component: () => import ("@/views/admin/Company/CompanyForm"),
            meta: {
              allowAccess: ["AdminSystem", "Customer"],
              page: "admin",
              code: ["FT003", "FT2303", "FT2306"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    },
                    {
                      path: "FormulaSetup",
                      name: "Admin-Salary-SalaryConfig-FormulaSetup",
                      component: () => import ("@/views/admin/Salary/SalaryConfig/SalaryFormulaSetup"),
                      meta: {
                        allowAccess: ["Customer"],
                        page: "admin",
                        code: ["FT1101"],
                        isOrtherModule: true,
                        collection: 'Timekeeping'
                      }
                    }
                  ]
              },
      //System/Branch
      {
        path: "System/Branch",
        name: "Admin-Branch",
        redirect: "/admin/Branch/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-Branch-list",
          component: () => import ("@/views/admin/Branch/BranchList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT501"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      {
        path: "System/TaskType",
        name: "Admin-TaskType",
        redirect: "/admin/TaskType/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-TaskType-list",
          component: () => import ("@/views/admin/TaskType/TaskTypeList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT501"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/Department
      {
        path: "System/Department",
        name: "Admin-Department",
        redirect: "/admin/Department/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-Department-list",
          component: () => import ("@/views/admin/Department/DepartmentList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT501"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/Position
      {
        path: "System/Position",
        name: "Admin-Position",
        redirect: "/admin/Position/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
            path: "list",
            name: "Admin-Position-list",
            component: () => import ("@/views/admin/Position/PositionList"),
            meta: {
              allowAccess: ["AdminSystem", "Customer"],
              page: "admin",
              code: ["FT501"],
              isOrtherModule: true,
              collection: 'Timekeeping'
            }
        }]
      },
      //System/SubsidiesSalaryType
      {
        path: "System/SubsidiesSalaryType",
        name: "Admin-SubsidiesSalaryType",
        redirect: "/admin/SubsidiesSalaryType/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-SubsidiesSalaryType-list",
          component: () => import ("@/views/admin/SubsidiesSalaryType/SubsidiesSalaryTypeList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT501"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/CoefficientSalary
      {
        path: "System/CoefficientSalary",
        name: "Admin-CoefficientSalary",
        redirect: "/admin/CoefficientSalary/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-CoefficientSalary-list",
          component: () => import ("@/views/admin/CoefficientSalary/CoefficientSalaryList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT501"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/ContractType
      {
        path: "System/ContractType",
        name: "Admin-ContractType",
        redirect: "/admin/ContractType/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-ContractType-list",
          component: () => import ("@/views/admin/ContractType/ContractTypeList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT501"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/Major
      {
        path: "System/Major",
        name: "Admin-Major",
        redirect: "/admin/System/Major/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-Major-list",
          component: () => import ("@/views/admin/Major/MajorList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT501"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/Qualification
      {
        path: "System/Qualification",
        name: "Admin-Qualification",
        redirect: "/admin/System/Qualification/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-Qualification-list",
          component: () => import ("@/views/admin/Qualification/QualificationList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT501"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/RankSalary
      {
        path: "System/RankSalary",
        name: "Admin-RankSalary",
        redirect: "/admin/System/RankSalary/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-RankSalary-list",
          component: () => import ("@/views/admin/RankSalary/RankSalaryList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT501"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/Relationship
      {
        path: "System/Relationship",
        name: "Admin-Relationship",
        redirect: "/admin/System/Relationship/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-Relationship-list",
          component: () => import ("@/views/admin/Relationship/RelationshipList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT501"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/RequestReason
      {
        path: "System/RequestReason",
        name: "Admin-RequestReason",
        redirect: "/admin/System/RequestReason/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-RequestReason-list",
          component: () => import ("@/views/admin/RequestReason/RequestReasonList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT601"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/DayOffCommon
      {
        path: "System/DayOffCommon",
        name: "Admin-DayOffCommon",
        redirect: "/admin/System/DayOffCommon/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-DayOffCommon-list",
          component: () => import ("@/views/admin/DayOffCommon/DayOffCommonList"),
          meta: {
            allowAccess: ["AdminSystem"],
            page: "admin",
            code: ["FT407"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/Role
      {
        path: "System/Role",
        name: "Admin-Role",
        redirect: "/admin/System/Role/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-Role-list",
          component: () => import ("@/views/admin/Role/RoleList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT1301"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/Asset
      {
        path: "System/Asset",
        name: "Admin-Asset",
        redirect: "/admin/System/Asset/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-Asset-list",
          component: () => import ("@/views/admin/Asset/AssetList"),
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["FT1601"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //System/Contract-Document
      {
        path: "System/Contract-Document",
        name: "Admin-Contract-Document",
        redirect: "/admin/System/Contract-Document/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-Contract-Document-list",
          component: () => import ("@/views/admin/EmployeeContract/EmployeeContract"),
          meta: {
            allowAccess: ["*"],
            page: "admin",
            code: ["FT2101"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //RoleFeature
      {
        path: "RoleFeature",
        name: "Admin-RoleFeature",
        redirect: "/admin/RoleFeature/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "list",
          name: "Admin-RoleFeature-list",
          component: () => import ("@/views/admin/RoleFeature/RoleFeatureList"),
          meta: {
            allowAccess: ["AdminSystem", "Customer"],
            page: "admin",
            code: ["FT1303"],
            isOrtherModule: true,
            collection: 'Timekeeping'
          }
        }]
      },
      //OrganizationSeal
      {
        path: "organization-seal",
        name: "Admin-OrganizationSeal",
        component: () => import ("@/views/admin/OrganizationSeal/OrganizationSeal"),
        meta: {
          allowAccess: ["*"],
          page: "admin",
          code: ["*"],
          breadCrumb: [],
          isOrtherModule: true,
          collection: 'Timekeeping'
        }
      },
      //Module config
      // {
      //   path: "ModuleConfig",
      //   name: "Admin-ModuleConfig",
      //   redirect: "/admin/ModuleConfig/list",
      //   component: {
      //     render(c) {
      //       return c("router-view");
      //     }
      //   },
      //   children: [
      //     {
      //       path: "list",
      //       name: "Admin-ModuleConfig-list",
      //       component: () => import("@/views/admin/ModuleConfig/ModuleConfig"),
      //       meta: {
      //         allowAccess: ["AdminSystem"],
      //         page: "admin",
      //         code: ["*"]
      //       }
      //     }
      //   ]
      // },
      //EmployeeInformation
      {
        path: "EmployeeInformation",
        name: "Admin-EmployeeInfo",
        redirect: "/admin/EmployeeInfo/detail",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "detail/:id",
          name: "Admin-EmployeeInfo-detail",
          component: () => import ("@/views/admin/Infomation/EmployeeInfo"),
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["*"],
            collection: 'UserInfo'
          }
        }]
      },
      //CompanyInformation
      {
        path: "CompanyInformation",
        name: "Admin-CompanyInfo",
        redirect: "/admin/CompanyInfo/detail",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [{
          path: "detail/:id",
          name: "Admin-CompanyInfo-detail",
          component: () => import ("@/views/admin/Company/CompanyForm"),
          meta: {
            allowAccess: ["Customer"],
            page: "admin",
            code: ["*"],
            collection: 'UserInfo'
          }
        }]
      },
      //Công việc
         {
        path: "AssignWork",
        name: "Admin-AssignWork",
        component: () => import("@/views/admin/AssignWork/AssignWork"),
        meta: {
          allowAccess: ["*"],
          page: "admin",
          code: ["*"],
          collection: 'AssignWork',
          breadCrumb: [
           {
              name: "Quản lý công việc",
              path: ""
            }
          ]
        }
      },
      // Mục văn bản
      {
        path: "CategoryManagement",
        name: "Admin-CategoryManagement",
        redirect: "/admin/CategoryManagement",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "DocumentType",
            name: "Admin-CategoryManagement-DocumentType",
            component: () => import("@/views/admin/CategoryManagement/DocumentType"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              // isOrtherModule: true,
              collection: 'Document',
            }
          },
          {
            path: "DocumentSecret",
            name: "Admin-CategoryManagement-DocumentSecret",
            component: () => import("@/views/admin/CategoryManagement/DocumentSecret"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              // isOrtherModule: true,
              collection: 'Document',
            }
          },
          {
            path: "DocumentUrgency",
            name: "Admin-CategoryManagement-DocumentUrgency",
            component: () => import("@/views/admin/CategoryManagement/DocumentUrgency"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              // isOrtherModule: true,
              collection: 'Document',
            }
          },
          {
            path: "DocumentOrganizationModel",
            name: "Admin-CategoryManagement-DocumentOrganizationModel",
            component: () => import("@/views/admin/CategoryManagement/DocumentOrganizationModel"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              // isOrtherModule: true,
              collection: 'Document',
            }
          },
          {
            path: "DocumentTextBook",
            name: "Admin-CategoryManagement-DocumentTextBook",
            component: () => import("@/views/admin/CategoryManagement/DocumentTextBook"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              // isOrtherModule: true,
              collection: 'Document',
            }
          },
          {
            path: "DocumentGroup",
            name: "Admin-CategoryManagement-DocumentGroup",
            component: () => import("@/views/admin/CategoryManagement/DocumentGroup"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              // isOrtherModule: true,
              collection: 'Document',
            }
          },
          {
            path: "DocumentBusiness",
            name: "Admin-CategoryManagement-DocumentBusiness",
            component: () => import("@/views/admin/CategoryManagement/DocumentBusiness"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              // isOrtherModule: true,
              collection: 'Document',
            }
          },
        ]
      },
      // Văn bản điện tử
      {
        path: "DocumentsGeneral",
        name: "Admin-DocumentsGeneral",
        component: () => import("@/views/admin/Documents/DocumentsGeneral"),
        meta: {
          allowAccess: ["Customer"],
          page: "admin",
          code: ["*"],
          collection: 'Document',
        }
      },
      // Văn bản đến
      {
        path: "ElectronicDocument",
        name: "Admin-ElectronicDocument",
        redirect: "/admin/ElectronicDocument",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "list",
            name: "Admin-ElectronicDocument-list",
            component: () => import("@/views/admin/ElectronicDocument/DocumentList"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Document',
            }
          },
          {
            path: "create",
            name: "Admin-ElectronicDocument-create",
            component: () => import("@/views/admin/ElectronicDocument/DocumentCreate"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Document',
            }
          },
          {
            path: "detail/:id",
            name: "Admin-ElectronicDocument-detail",
            component: () => import("@/views/admin/ElectronicDocument/DocumentDetail"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Document',
            }
          },
          {
            path: "transfer/:id",
            name: "Admin-ElectronicDocument-transfer",
            component: () => import("@/views/admin/ElectronicDocument/DocumentTransfer"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Document',
            }
          },
          {
            path: "transfer-for-other-company/:id",
            name: "Admin-ElectronicDocument-transfer-for-other-company",
            component: () => import("@/views/admin/ElectronicDocument/DocumentTransferForOtherCompany"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Document',
            }
          },
          {
            path: "promulgate/:id",
            name: "Admin-ElectronicDocument-promulgate",
            component: () => import("@/views/admin/ElectronicDocument/DocumentPromulgate"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Document',
            }
          },
          {
            path: "sign/:id",
            name: "Admin-ElectronicDocument-sign",
            component: () => import("@/views/admin/ElectronicDocument/DocumentSign"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Document',
            }
          },
          {
            path: "sign-request/:id",
            name: "Admin-ElectronicDocument-signRequest",
            component: () => import("@/views/admin/ElectronicDocument/DocumentSignRequest"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Document',
            }
          },
          {
            path: "template-create",
            name: "Admin-ElectronicDocument-template-create",
            component: () => import("@/views/admin/ElectronicDocument/DocumentTemplateCreate"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Document',
            }
          },
          {
            path: "template-form",
            name: "Admin-ElectronicDocument-template-form",
            component: () => import("@/views/admin/ElectronicDocument/DocumentTemplateForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Document',
            }
          },
        ]
      },
      //Soạn thảo văn bản
      {
        path: "document-drafting",
        name: "Admin-DocumentDrafting",
        redirect: "/admin/document-drafting/list",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          // {
          //   path: "dashboard",
          //   name: "Admin-DocumentDrafting-Dashboard",
          //   component: () => import("@/views/admin/DocumentDrafting/Dashboard"),
          //   meta: {
          //     allowAccess: ["Customer"],
          //     page: "admin",
          //     code: ["*"],
          //     collection: 'DocumentDrafting',
          //     // isOrtherModule: true,
          //     breadCrumb: [
          //       {
          //         name: "Hợp đồng điện tử",
          //         path: "/admin/document-drafting/dashboard"
          //       },
          //     ]
          //   }
          // },
          {
            path: "list",
            name: "Admin-DocumentDrafting-list",
            component: () => import("@/views/admin/DocumentDrafting/Composer/DocumentDraftingList"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              // isOrtherModule: true,
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: ""
                }
              ]
            }
          },
          {
            path: "template-categories",
            name: "Admin-DocumentDrafting-category-list",
            component: () => import("@/views/admin/DocumentDrafting/Category/DdaCategoryList"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: "DocumentDrafting",
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Quản lý loại mẫu",
                  path: ""
                }
              ]
            }
          },
          {
            path: "templates",
            name: "Admin-DocumentDrafting-template-list",
            component: () => import("@/views/admin/DocumentDrafting/Template/DdaTemplateList"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: "DocumentDrafting",
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Quản lý mẫu văn bản",
                  path: ""
                }
              ]
            }
          },
          {
            path: "create",
            name: "Admin-DocumentDrafting-create",
            component: () => import("@/views/admin/DocumentDrafting/Composer/DocumentDraftingCreate"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              // isOrtherModule: true,
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Tạo văn bản",
                  path: ""
                }
              ]
            }
          },
          {
            path: "create-drafting",
            name: "Admin-DocumentDrafting-create-drafting",
            component: () => import("@/views/admin/DocumentDrafting/Composer/DocumentDraftingForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              // isOrtherModule: true,
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Tạo văn bản",
                  path: ""
                }
              ]
            }
          },
          {
            path: "detail-drafting/:id",
            name: "Admin-DocumentDrafting-detail-drafting",
            component: () => import("@/views/admin/DocumentDrafting/Composer/DocumentDraftingForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              // isOrtherModule: true,
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Thông tin chi tiết",
                  path: ""
                }
              ]
            }
          },
          {
            path: "update/:id",
            name: "Admin-DocumentDrafting-update",
            component: () => import("@/views/admin/DocumentDrafting/Composer/DocumentDraftingCreate"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              // isOrtherModule: true,
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Cập nhật văn bản",
                  path: ""
                }
              ]
            }
          },
          {
            path: "update-drafting/:id",
            name: "Admin-DocumentDrafting-update-drafting",
            component: () => import("@/views/admin/DocumentDrafting/Composer/DocumentDraftingForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              // isOrtherModule: true,
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Chi tiết văn bản",
                  path: ""
                }
              ]
            }
          },
          {
            path: "sign-approve/:id",
            name: "Admin-DocumentDrafting-sign-approve",
            component: () => import("@/views/admin/DocumentDrafting/Composer/DocumentDraftingSignApproval"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              // isOrtherModule: true,
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Ký duyệt văn bản",
                  path: ""
                }
              ]
            }
          },
          {
            path: "sign-process/:id",
            name: "Admin-DocumentDrafting-sign-process",
            component: () => import("@/views/admin/DocumentDrafting/Composer/DocumentDraftingSignProcess"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              // isOrtherModule: true,
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Trình ký văn bản",
                  path: ""
                }
              ]
            }
          },
          {
            path: "detail-approve/:id",
            name: "Admin-DocumentDrafting-detail-approve",
            component: () => import("@/views/admin/DocumentDrafting/Composer/DocumentDraftingDetailAprove"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              // isOrtherModule: true,
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Thông tin chi tiết",
                  path: ""
                }
              ]
            }
          }
        ]
      },
      //Hợp đồng lưu trữ
      {
        path: 'document-archived',
        name: 'Admin-Document-Archived',
        redirect: '/admin/document-archived/list',
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "list",
            name: "Admin-Document-Archived-list",
            component: () => import("@/views/admin/DocumentDrafting/Archived/ArchivedList"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Hợp đồng lưu trữ",
                  path: ""
                }
              ]
            }
          },
          {
            path: "create",
            name: "Admin-Document-Archived-create",
            component: () => import("@/views/admin/DocumentDrafting/Archived/ArchivedForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Hợp đồng lưu trữ",
                  path: "/admin/document-archived/list"
                },
                {
                  name: "Thêm mới hợp đồng lưu trữ",
                  path: ""
                },
              ]
            }
          },
          {
            path: "update/:id",
            name: "Admin-Document-Archived-update",
            component: () => import("@/views/admin/DocumentDrafting/Archived/ArchivedForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Hợp đồng lưu trữ",
                  path: "/admin/document-archived/list"
                },
                {
                  name: "Cập nhật hợp đồng lưu trữ",
                  path: ""
                },
              ]
            }
          },
          {
            path: "detail/:id",
            name: "Admin-Document-Archived-detail",
            component: () => import("@/views/admin/DocumentDrafting/Archived/ArchivedForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'DocumentDrafting',
              breadCrumb: [
                {
                  name: "Hợp đồng điện tử",
                  path: "/admin/document-drafting/list"
                },
                {
                  name: "Hợp đồng lưu trữ",
                  path: "/admin/document-archived/list"
                },
                {
                  name: "Chi tiết hợp đồng lưu trữ",
                  path: ""
                },
              ]
            }
          }
        ]
      },
      //Thiết lập
      {
        path: "settings",
        name: "Admin-Settings",
        redirect: "/admin/settings/electronic-contract-templates",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "electronic-contract-templates",
            name: "Admin-Settings-ElectronicContractTemplate-list",
            component: () => import("@/views/admin/Settings/ElectronicContractTemplateConfig"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              isOrtherModule: true,
              collection: "Timekeeping",
              breadCrumb: [
                {
                  name: "Thiết lập",
                  path: ""               
                },
                {
                  name: "Cấu hình mẫu hợp đồng điện tử",
                  path: ""                
                }
              ]
            }
          },
          {
            path: "electronic-document-templates",
            name: "Admin-Settings-ElectronicDocumentTemplate-list",
            component: () => import("@/views/admin/Settings/ElectronicTemplateConfig"),
            props: {
              templateKind: "DOCUMENT"
            },
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              isOrtherModule: true,
              collection: "Timekeeping",
              breadCrumb: [
                {
                  name: "Thiết lập",
                  path: ""
                },
                {
                  name: "Cấu hình mẫu văn bản điện tử",
                  path: ""
                }
              ]
            }
          }
        ]
      },
      //Kinh doanh
      {
        path: 'business',
        name: 'Admin-Business',
        redirect: '/admin/business/list',
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "list",
            name: "Admin-Business-list",
            component: () => import("@/views/admin/Business/BusinessList"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Business',
            }
          },
          {
            path: "create",
            name: "Admin-Business-create",
            component: () => import("@/views/admin/Business/BusinessForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Business',
            },
          },
          {
            path: "update/:id",
            name: "Admin-Business-update",
            component: () => import("@/views/admin/Business/BusinessForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["*"],
              collection: 'Business',
            },
          },
        ]
      },
      //Tin tức
      {
        path: 'news',
        name: 'Admin-News',
        redirect: '/admin/news/list',
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "list",
            name: "Admin-News-list",
            component: () => import("@/views/admin/News/NewsList/NewsList"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT2200", "FT2201"],
              collection: 'News',
            }
          },
          {
            path: "config/news-category",
            name: "Admin-NewsCategory-list",
            component: () => import ("@/views/admin/News/NewsCategory/NewsCategoryList"),
            meta: {
              allowAccess: ["AdminSystem", "Customer"],
              page: "admin",
              code: ["FT2206"],
              collection: 'News'
            }
          },
          {
            path: "create",
            name: "Admin-News-create",
            component: () => import("@/views/admin/News/NewsList/NewsCreateForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT2202"],
              collection: 'News',
            },
          },
          {
            path: "update/:id",
            name: "Admin-News-update",
            component: () => import("@/views/admin/News/NewsList/NewsUpdateForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT2203","FT2204"],
              collection: 'News',
            },
          },
          {
            path: "detail/:id",
            name: "Admin-News-detail",
            component: () => import("@/views/admin/News/NewsList/NewsDetailForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT2200", "FT2201"],
              collection: 'News',
            },
          },
          {
            path: "publish/:id",
            name: "Admin-News-publish",
            component: () => import("@/views/admin/News/NewsList/NewsUpdateForm"),
            meta: {
              allowAccess: ["Customer"],
              page: "admin",
              code: ["FT2203"],
              collection: 'News',
            },
          },
        ]
      },
    ]
  },
  //danmgKy
  {
    path: "/dangky",
    name: "Auth-RegisterUser",
    component: () => import ("@/views/auth/Register"),
    meta: {
      page: "auth"
    }
  },
  //auth
  {
    path: "/auth",
    redirect: "/auth/login",
    name: "Auth",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    },
    children: [
      {
        path: "404",
        name: "Auth-Page404",
        component: () => import ("@/views/auth/Page404"),
        meta: {
          page: "auth"
        }
      },
      {
        path: "login",
        name: "Auth-Login",
        component: () => import ("@/views/auth/Login"),
        meta: {
          page: "auth"
        }
      },
      {
        path: "shared-login",
        name: "Auth-SharedLogin",
        component: () => import ("@/views/auth/SharedLoginRedirect"),
        meta: {
          page: "auth"
        }
      },
      {
        path: "changepassword",
        name: "Auth-ChangePassword",
        component: () => import ("@/views/auth/ChangePassword"),
        meta: {
          allowAccess: ["*"],
          code: ["*"],
          page: "auth"
        }
      },
      {
        path: "forgotPassword",
        name: "Auth-ForgotPassword",
        component: () => import ("@/views/auth/ForgotPassword"),
        meta: {
          page: "auth"
        }
      },
      {
        path: "resetPassword",
        name: "Auth-ResetPassword",
        component: () => import ("@/views/auth/ResetPassword"),
        meta: {
          page: "auth"
        }
      },
      {
        path: "gov-login",
        name: "Auth-Login-Goverment",
        component: () => import ("@/views/auth/LoginGoverment"),
        meta: {
          page: "auth"
        }
      }
    ]
  }
]
